/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-26 11:24:12
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2026-01-16 14:40:53
 * @FilePath: /qd-yunjing-web/src/router/modules/safety.ts
 * @Description: 这是默认设置,请设置`customMade`, BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export const spaceRoutes: RouteRecordRaw[] = [
  {
    path: '/space',
    name: 'space-root',
    component: Layout,
    meta: {
      authCodes: ['SPACE'],
      icon: 'BarFull',
      title: '空间',
    },
    children: [
      {
        path: '/space/space-tree/index',
        name: 'space-tree-index',
        component: () => import('@/views/space/space-tree/index.vue'),
        meta: {
          authCodes: ['SPACE_TREE'],
          title: '空间树管理',
          projectCheckStrictly: true,
          activeMenu: '/space',
        },
      },
      {
        path: '/space/device-ledger/index',
        name: 'device-ledger-index',
        component: () => import('@/views/space/device-ledger/index.vue'),
        meta: {
          authCodes: ['DEVICE_LEDGER'],
          title: '设备台账',
          projectCheckStrictly: true,
          activeMenu: '/space',
        },
      },
      {
        path: '/space/model-config',
        name: 'model-config-index',
        meta: {
          authCodes: ['MODEL_CONFIG'],
          title: '模型配置',
          activeMenu: '/space',
        },
        children: [
          {
            path: '/space/model-config/equipment-icon-config',
            name: 'equipment-icon-config',
            component: () => import('@/views/space/model-config/equipment-icon-config.vue'),
            meta: {
              authCodes: ['QEUIPMENT_ICON_CONFIG'],
              title: '设备图标配置',
              hideSelectProject: true,
              activeMenu: '/space',
            },
          },
          {
            path: '/space/model-config/order-icon-config',
            name: 'order-icon-config',
            component: () => import('@/views/space/model-config/order-icon-config.vue'),
            meta: {
              authCodes: ['ORDER_ICON_CONFIG'],
              title: '工单图标配置',
              activeMenu: '/space',
              projectCheckStrictly: true,
            },
          }
        ],
      }
    ],
  }
];
